import { Injectable, Signal, computed } from '@angular/core';
import { IOtpData, IOtpModel } from '@partners/api';
import { StateAccessService } from '../../../services';

import { Observable } from 'rxjs';
import { AuthActions, AuthSelectors, IAuthOtpState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class AuthOtpStore extends StateAccessService<IAuthOtpState> {
  state$: Observable<IAuthOtpState<IOtpModel, IOtpData>>;

  readonly model$$: Signal<IOtpModel>;
  readonly data$$: Signal<IOtpData>;
  readonly token$$: Signal<string>;
  readonly sendOtpAttemptsCount$$: Signal<number>;
  readonly isMultipleOtpSendAttempts$$: Signal<boolean>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(AuthSelectors.otpModel);
    this.data$$ = this.stateFacade.selectSignal$(AuthSelectors.otpData);
    this.sendOtpAttemptsCount$$ = this.stateFacade.selectSignal$(AuthSelectors.otpSendAttemptsCount);
    this.isMultipleOtpSendAttempts$$ = computed(() => this.sendOtpAttemptsCount$$() > 1);
    this.token$$ = super.stateFacade.selectSignal$(AuthSelectors.token);
  }

  dispatchAuthOtpReset() {
    this.stateFacade.dispatch(AuthActions.resetOtp());
  }

  /**
   * auth otp dispatches
   */
  dispatchOtpLoad() {
    this.stateFacade.dispatch(AuthActions.loadOtp());
  }

  dispatchUpdateOtpAttemptsCount() {
    this.stateFacade.dispatch(AuthActions.incOtpSendAttemptCount());
  }
  dispatchOtpUpdateModel({ model }: { model: IOtpModel }) {
    this.stateFacade.dispatch(AuthActions.updateOtpModel({ model }));
  }
  dispatchOtpLoadSuccess({ model, data }: { model: IOtpModel; data: IOtpData }) {
    this.stateFacade.dispatch(AuthActions.loadOtpSuccess({ model, data }));
  }
  dispatchOtpLoadFailure(error: any) {
    this.stateFacade.dispatch(AuthActions.loadOtpFailure(error));
  }
  dispatchOtpSubmit({ model }: { model: IOtpModel }) {
    this.stateFacade.dispatch(AuthActions.submitOtp({ model }));
  }
  dispatchOtpSubmitSuccess({ data }: { data: IOtpData }) {
    this.stateFacade.dispatch(AuthActions.submitOtpSuccess({ data }));
  }
  dispatchOtpSubmitFailure(error: any) {
    this.stateFacade.dispatch(AuthActions.submitOtpFailure(error));
  }
}
